<h2 mat-dialog-title>Karussel-Element {{ isEditMode ? 'bearbeiten' : 'erstellen' }}</h2>
<mat-dialog-content>

  <form [formGroup]="slideForm"  class="mt-l">
    <mat-form-field appearance="outline">
      <mat-label>Titel</mat-label>
      <input
        matInput
        autocomplete="off"
        placeholder="Titel"
        formControlName="title">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Link</mat-label>
      <input
        matInput
        autocomplete="off"
        placeholder="Link"
        formControlName="link">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Termin</mat-label>
      <mat-date-range-input [rangePicker]="range">
        <input matStartDate placeholder="Startdatum" formControlName="start">
        <input matEndDate placeholder="Enddatum" formControlName="end">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="range"></mat-datepicker-toggle>
      <mat-date-range-picker #range></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Position</mat-label>
      <input
        matInput
        autocomplete="off"
        type="number"
        placeholder="Position"
        formControlName="order">
    </mat-form-field>

    <!--    <mat-form-field appearance="outline" class="w-100">-->
    <!--      <mat-label>Hersteller</mat-label>-->
    <!--      <mat-select-->
    <!--        placeholder="Hersteller"-->
    <!--        formControlName="vendor">-->
    <!--        @for (vendor of vendors(); track vendor.id) {-->
    <!--          <mat-option [value]="vendor.id">-->
    <!--            {{ vendor.name }}-->
    <!--          </mat-option>-->
    <!--        }-->
    <!--      </mat-select>-->
    <!--    </mat-form-field>-->
<!--    <mat-form-field appearance="outline">-->
<!--      <mat-label>Bild</mat-label>-->
      <input type="file"
             accept="image/*"
             name="imagePath"
             #imageSlide
             (change)="imagePath($event)"
             formControlName="image">
  </form>
</mat-dialog-content>

<mat-dialog-actions class="p-m">
  <button mat-button mat-dialog-close color="neutral">Abbrechen</button>
  <button mat-flat-button
          [disabled]="!isFormValid()"
          color="primary"
          (click)="onSubmit()">Element {{ isEditMode ? 'aktualisieren' : 'speichern' }}</button>
</mat-dialog-actions>
